window.onYouTubePlayerAPIReady = -> Backbone.trigger("youtubeplayerapiready")
tag      = document.createElement("script")
protocol = window.location.protocol.replace("file", "http")
if __?.slidedeck?.platform is "iOS"
  protocol = window.location.protocol.replace("ionic", "http")
tag.src  = "#{protocol}//www.youtube.com/player_api"
document.head.appendChild(tag, "beforeEnd")
